// Registers public/service-worker.js in production builds so the app can be installed (PWA).
// Skipped in development to avoid serving stale bundles while the dev server is running.
export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .catch((error) => {
        console.error('Service worker registration failed:', error);
      });
  });
}
